(() => {
  const modal = document.querySelector('[data-cart-save-offer]');
  if (!modal) return;

  const discountCode = modal.dataset.discountCode || '4YOU';
  const minCartItems = Number(modal.dataset.minCartItems || 1);
  const customerOrders = Number(modal.dataset.customerOrders || 0);
  const storageKey = 'st_cart_save_offer_seen';
  const dayInMs = 24 * 60 * 60 * 1000;
  let isCheckingCart = false;
  let lastScrollY = window.scrollY;
  let hasOpened = false;

  const recentlySeen = () => {
    const seenAt = Number(window.localStorage.getItem(storageKey) || 0);
    return seenAt && Date.now() - seenAt < dayInMs;
  };

  const markSeen = () => {
    window.localStorage.setItem(storageKey, String(Date.now()));
  };

  const openOffer = async () => {
    if (customerOrders > 0) return;
    if (hasOpened || recentlySeen() || isCheckingCart) return;
    isCheckingCart = true;

    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
      });
      const cart = await response.json();
      if ((cart?.item_count || 0) < minCartItems) return;

      hasOpened = true;
      markSeen();
      modal.hidden = false;
      document.documentElement.classList.add('overflow-hidden');
      modal.querySelector('.st-cart-save-offer__button')?.setAttribute(
        'href',
        `/discount/${encodeURIComponent(discountCode)}?redirect=/checkout`
      );
      modal.querySelector('.st-cart-save-offer__close')?.focus();
    } catch (error) {
      // If the cart cannot be checked, do not interrupt the shopper.
    } finally {
      isCheckingCart = false;
    }
  };

  const closeOffer = () => {
    modal.hidden = true;
    document.documentElement.classList.remove('overflow-hidden');
  };

  modal.querySelectorAll('[data-cart-save-close]').forEach((button) => {
    button.addEventListener('click', closeOffer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeOffer();
  });

  document.addEventListener('mouseout', (event) => {
    if (event.relatedTarget || event.clientY > 24 || event.clientX < window.innerWidth - 220) return;
    openOffer();
  });

  window.addEventListener(
    'scroll',
    () => {
      const currentY = window.scrollY;
      const scrollingUpFast = lastScrollY - currentY > 70;
      const nearTop = currentY < 120;
      lastScrollY = currentY;

      if (window.matchMedia('(max-width: 749px)').matches && scrollingUpFast && nearTop) {
        openOffer();
      }
    },
    { passive: true }
  );

  window.setTimeout(() => {
    if (window.matchMedia('(max-width: 749px)').matches) openOffer();
  }, 45000);
})();
